import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Carousel from "react-bootstrap/Carousel";
import Host from "../../Components/Host";
import { useMediaQuery } from "react-responsive";
import TrustBadges from "../../Pages/Home/TrustBadges";

function HomeCarousel() {
  const { userId, userToken, userEmail, languageCode, countryCode, cartToken } = useSelector((state) => state.auth);
  const isMobcreen = useMediaQuery({ query: "(min-width: 0px) and (max-width: 768px)" });

  const thisclass = "hp-carouselth";

  const trustTop = [
    { icon: "/4.png", title: "100% Authentic", subtitle: "Genuine Products" },
    {
      icon: "/3.png",
      title: "Premium Quality",
      subtitle: "Curated with care",
    },
    { icon: "/2.png", title: "Easy return", subtitle: "Hassle-free return" },
    { icon: "/1.png", title: "Secure Payments", subtitle: "Your payment are safe" },
  ];

  return (
    <>
      {isMobcreen ? (
        <Carousel className={`hp-carousel ${thisclass}`} fade>
          {Host?.bannerMobileImages?.map((item, i) => (
            <Carousel.Item key={i} interval={5500} style={{ objectFit: "cover" }}>
              <Link to={`${item.link}`}>
                <img loading="lazy" className="Dashboard-board-img" src={item?.image} style={{ objectFit: "cover" }} />
              </Link>
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <>
          <Carousel className={`hp-carousel ${thisclass}`} fade>
            {Host?.bannesImages?.map((item, i) => (
              <Carousel.Item key={i} interval={5500} style={{ objectFit: "cover" }}>
                <Link to={`${item.link}`}>
                  <img
                    loading="lazy"
                    className="Dashboard-board-img"
                    src={item?.image}
                    style={{ objectFit: "cover" }}
                  />
                </Link>
              </Carousel.Item>
            ))}
          </Carousel>
        </>
      )}
      <div className="container">
        <TrustBadges items={trustTop} variant="boxed" />
      </div>
    </>
  );
}

export default HomeCarousel;
